import { Typography } from "@mui/material"
import React, { type ReactElement } from "react"

import DisplayAS400Id from "@/components/common/DisplayAS400Id/DisplayAS400Id"

interface DisplayIdsProps {
  entityName: string
  publicId?: string | null
  externalSystemId?: string | null
}

const DisplayIds = ({ entityName, publicId, externalSystemId }: DisplayIdsProps): ReactElement => {
  return (
    <>
      <Typography variant='body1' className='font-medium text-gray-700'>
        {entityName}&nbsp;
        <span className='text-sm font-bold'>{publicId}</span>
      </Typography>
      <DisplayAS400Id id={externalSystemId} />
    </>
  )
}

export default DisplayIds
